import en_US from './en_US';
import de_DE from './de_DE';
import es_ES from './es_ES';
import es_MX from './es_MX';
import fr_FR from './fr_FR';
import it_IT from './it_IT';
import ja_JP from './ja_JP';
import ko_KR from './ko_KR';
import ms_MY from './ms_MY';
import pt_BR from './pt_BR';
import pt_PT from './pt_PT';
import ru_RU from './ru_RU';
import th_TH from './th_TH';
import tr_TR from './tr_TR';
import zh_HK from './zh_HK';
import zh_TW from './zh_TW';

export default {
	en_US,
	de_DE,
	es_ES,
	es_MX,
	fr_FR,
	it_IT,
	ja_JP,
	ko_KR,
	ms_MY,
	pt_BR,
	pt_PT,
	ru_RU,
	th_TH,
	tr_TR,
	zh_HK,
	zh_TW,
};
